import type { TypographyOwnProps } from '@mui/material';

export const headerSizes: Record<1 | 2 | 3 | 4 | 5 | 6, TypographyOwnProps['variant']> = {
  1: 'h6',
  2: 'h5',
  3: 'h4',
  4: 'h3',
  5: 'h2',
  6: 'h1',
};
